"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var react_apollo_1 = require("react-apollo");
var graphql_tag_1 = require("graphql-tag");
var react_tracking_1 = require("react-tracking");
var lodash_1 = require("lodash");
var elog = require("../../elog");
var tracker_1 = require("../../tracker");
var core_link_1 = require("../../components/core_link");
var article_collection_view_1 = require("../../components/article_collection_view");
var COMPONENT_NAME = 'ArticleCollection';
var SIDEBAR_SECTION = 'sidebar';
var ArticleCollection = /** @class */ (function (_super) {
    tslib_1.__extends(ArticleCollection, _super);
    function ArticleCollection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ArticleCollection.prototype.componentDidMount = function () {
        if (!this.props.data.loading && this.articles().length) {
            this.props.tracking.trackEvent({
                eventType: tracker_1.VIEW,
                ids: this.articles().map(function (article) { return article.id; }),
            });
        }
    };
    ArticleCollection.prototype.componentDidUpdate = function (oldProps) {
        if (!this.props.data.loading && this.articles().length && !lodash_1.isEqual(this.props.data, oldProps.data)) {
            this.props.tracking.trackEvent({
                eventType: tracker_1.VIEW,
                ids: this.articles().map(function (article) { return article.id; }),
            });
        }
    };
    ArticleCollection.prototype.getBackgroundImageStyle = function (article) {
        var src = lodash_1.get(article.images[0], 'source');
        if (!src)
            return null;
        return { backgroundImage: "url(" + article.images[0].source + ")" };
    };
    ArticleCollection.prototype.articles = function () {
        return this.props.data.articles || [];
    };
    ArticleCollection.prototype.renderAction = function () {
        if (!this.props.ctaTargetHref)
            return;
        return (React.createElement(core_link_1.default, { to: this.props.ctaTargetHref, interactionType: tracker_1.CTA }, this.props.ctaText
            ? this.props.ctaText
            : I18n.t('cms.articleCollection.readMore')));
    };
    ArticleCollection.prototype.render = function () {
        try {
            if (!this.props.data.loading && !this.articles().length)
                return null;
            return (React.createElement(article_collection_view_1.default, { title: this.props.title, titleHtml: this.props.titleHtml, subtitleHtml: this.props.subtitleHtml, ledeHtml: this.props.ledeHtml, action: this.renderAction(), articles: this.articles(), id: this.props.jumplinkSlug, loading: this.props.data.loading, expectedCount: lodash_1.get(this.props, 'articleIds.length'), renderForSidebar: this.props.layoutSection === SIDEBAR_SECTION }));
        }
        catch (e) {
            elog.error("RenderError (" + COMPONENT_NAME + ")", {}, e);
            return null;
        }
    };
    ArticleCollection = tslib_1.__decorate([
        react_tracking_1.default(function (props) {
            return {
                componentName: COMPONENT_NAME,
                type: tracker_1.ARTICLE_TYPE,
                context: {
                    title: props.title,
                    layoutSection: props.layoutSection,
                    pagePosition: props.pagePosition,
                }
            };
        })
    ], ArticleCollection);
    return ArticleCollection;
}(React.Component));
exports.ArticleCollection = ArticleCollection;
var connect = react_apollo_1.graphql(graphql_tag_1.default(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  query Commons_Cms_ArticlesCollection(\n    $ids: [String]\n  ) {\n    articles(input: { ids: $ids }) {\n      id\n      title\n      articleCategories {\n        name\n      }\n      webLink {\n        href\n      }\n      images(input:{\n        type: \"Article\",\n        scope: \"full_bleed_image\",\n        transform: \"card_wide\"\n      }) {\n        source\n      }\n    }\n  }\n  "], ["\n  query Commons_Cms_ArticlesCollection(\n    $ids: [String]\n  ) {\n    articles(input: { ids: $ids }) {\n      id\n      title\n      articleCategories {\n        name\n      }\n      webLink {\n        href\n      }\n      images(input:{\n        type: \"Article\",\n        scope: \"full_bleed_image\",\n        transform: \"card_wide\"\n      }) {\n        source\n      }\n    }\n  }\n  "]))), {
    options: function (ownProps) { return ({
        ssr: ownProps.ssr,
        variables: {
            ids: ownProps.articleIds,
        },
    }); },
});
exports.default = connect(ArticleCollection);
var templateObject_1;
//# sourceMappingURL=article_collection.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/cms/components/article_collection.js
// module id = IOza
// module chunks = 0 2 6 8 20